'use client';
import React, { useState } from 'react';
import { Plus, Crown } from 'lucide-react';
import AddDogModal from './AddDogModal';

export default function MyDogsHeader() {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className="flex items-start justify-between mb-8">
        <div>
          <h1 className="text-2xl font-700 text-foreground">My Dogs</h1>
          <p className="text-sm text-muted-foreground mt-1">Manage your dog profiles, memories, and achievements.</p>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1.5 bg-primary/10 text-primary px-3 py-1.5 rounded-full text-xs font-700">
            <Crown size={12} />
            Premium · Unlimited profiles
          </div>
          <button
            onClick={() => setShowModal(true)}
            className="paw-btn flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-xl text-sm font-700 hover:bg-secondary-foreground transition-all shadow-elevated"
          >
            <Plus size={16} />
            Add Dog
          </button>
        </div>
      </div>
      <AddDogModal open={showModal} onClose={() => setShowModal(false)} />
    </>
  );
}